import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { IInsightsFilter } from '@innerhive-internal/innerhive-common';
import { BRAND, CHART_INK, describeFilter } from './agencyChartTheme';

const useStyles = createUseStyles({
    // The narrowing bar takes the coral so it reads as a temporary state laid over the map rather
    // than part of it, and so it is impossible to leave one on without noticing.
    bar: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap' as const,
        marginBottom: 14,
        padding: '10px 14px',
        borderRadius: 10,
        border: `1px solid ${BRAND.coral}`,
        background: BRAND.coralWash
    },

    text: {
        flex: 1,
        minWidth: 180,
        fontSize: 13,
        lineHeight: 1.45,
        color: CHART_INK.strongLabel
    },

    strong: {
        fontWeight: 600,
        color: BRAND.deepTeal
    },

    action: {
        border: `1px solid ${BRAND.tealEdge}`,
        borderRadius: 20,
        padding: '5px 13px',
        font: 'inherit',
        fontSize: 12.5,
        color: BRAND.deepTeal,
        background: 'var(--ion-background-color)',
        cursor: 'pointer',

        '@media print': {
            display: 'none'
        }
    }
});

/** What the caseload map is currently narrowed to, in words, with the way back out. */
export const InsightsFilterBar: FC<{
    filter: IInsightsFilter;
    clientCount: number;
    onClear: () => void;
}> = ({ filter, clientCount, onClear }) => {
    const classes = useStyles();

    return (
        <div className={classes.bar} data-id="insights-filter-bar">
            <span className={classes.text}>
                Showing <span className={classes.strong}>{describeFilter(filter)}</span>:
                {' '}{clientCount} client{clientCount === 1 ? '' : 's'}.
            </span>
            <button
                type="button"
                className={classes.action}
                data-id="insights-filter-clear"
                onClick={onClear}
            >
                Clear
            </button>
        </div>
    );
};
